// HowItWorks.tsx
import React from "react";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import "./HomePage.scss";

interface HowItWorksProps {
  setIsCartOpen?: (isOpen: boolean) => void;
}

const HowItWorks: React.FC<HowItWorksProps> = ({ setIsCartOpen }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  // Using the local image from public directory
  const desktopImage = "/How it works for web.jpg";
  const mobileImage = "/How it works for web.jpg";

  return (
    <Box className="how-it-works">
      {isMobile ? (
        <Box className="mobile-vertical">
          <img
            src={mobileImage}
            alt="How it works on mobile"
            style={{ width: "100%", height: "auto" }}
            loading="lazy"
          />
        </Box>
      ) : (
        <Box className="step1">
          <img 
            src={desktopImage}
            alt="How it works on desktop"
            style={{ width: "100%", height: "auto" }}
            loading="lazy"
          />
        </Box>
      )}
      
      {/* Uncomment and use this when you want to enable the CTA button */}
      {/* {setIsCartOpen && (
        <Box className="cta-button" sx={{ mt: 2, textAlign: 'center' }}>
          <Button 
            variant="contained" 
            color="primary" 
            onClick={() => setIsCartOpen(true)}
            sx={{ px: 4, py: 1.5 }}
          >
            Book your Appointment Now
          </Button>
        </Box>
      )} */}
    </Box>
  );
};

export default HowItWorks;
